(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const CharityPayoutChart = svs.lyckoplatsen.components.shared_charity_payout.react.components.CharityPayoutChart;
const charityPayoutChartAtom = svs.lyckoplatsen.shared_charity_payout.jotai.atoms.charityPayoutChartAtom;
const useCharityPayout = svs.lyckoplatsen.components.shared_charity_payout.react.hooks.useCharityPayout;
const CharityPayout = () => {
  const _useState = useState(svs.core.detect.breakpoint.greaterThan('am')),
    _useState2 = _slicedToArray(_useState, 2),
    isHorizontal = _useState2[0],
    setIsHorizontal = _useState2[1];
  const charityPayoutChart = useAtomValue(charityPayoutChartAtom);
  useCharityPayout();
  useEffect(() => {
    const listener = () => {
      if (svs.core.detect.breakpoint.lessThan('am')) {
        setIsHorizontal(false);
      } else {
        setIsHorizontal(true);
      }
    };
    svs.core.detect.breakpoint.on('change', listener);
    return () => svs.core.detect.breakpoint.off('change', listener);
  }, []);
  if (!charityPayoutChart) {
    return React.createElement("div", {
      className: "lp-charity-payout"
    }, React.createElement("div", {
      className: "charity-body"
    }, React.createElement("div", {
      className: "lp-header f-content"
    }, React.createElement("h3", null, "Tyv\xE4rr kunde vi inte hitta ", React.createElement("br", null), "f\xF6rdelningen av bidrag till v\xE5ra ", React.createElement("br", null), "samarbetsorganisationer f\xF6r ", React.createElement("br", null), "denna dragning."))));
  }
  return React.createElement("div", {
    className: "lp-charity-payout"
  }, React.createElement("div", {
    className: "charity-body"
  }, React.createElement("div", {
    className: "lp-header f-content"
  }, React.createElement("h3", null, "M\xE5nga vinner n\xE4r du spelar. ", React.createElement("br", null), " S\xE5 h\xE4r f\xF6rdelades v\xE5rt st\xF6d", React.createElement("br", null), " till v\xE4lg\xF6renhet i denna ", React.createElement("br", null), "dragning.")), React.createElement("div", {
    className: "chart-wrapper"
  }, React.createElement(CharityPayoutChart, {
    payoutChartData: charityPayoutChart,
    className: "text-white",
    horizontal: isHorizontal
  }))));
};
setGlobal('svs.lyckoplatsen.components.shared_charity_payout.react.components', {
  CharityPayout
});

 })(window);